module.exports = __webpack_public_path__ + "static/media/1 Train-AP_Z2.cc5a09e1.png";